<template>
  <v-container
    id="login"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          width="500"
          style="z-index: 1"
        >
          <template v-slot:heading>
            <span class="text-center">ЛИЧНЫЙ КАБИНЕТ</span>
          </template>
          <v-card-text class="text-center">
            <v-tabs>
              <v-tab>Авторизация</v-tab>
              <v-tab>Регистрация</v-tab>
              <v-tab-item>
                <v-text-field
                  v-model="form.phone"
                  color="secondary"
                  :label="label"
                  :prepend-icon="icon"
                  :counter="counter"
                  :maxlength="maxlength"
                  :rules="loginrules"
                  :disabled="sms.show || load"
                  :prefix="phone?'+7':null"
                  autofocus
                  @input="login_input"
                />
                <v-text-field
                  v-model="form.password"
                  :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show3 ? 'text' : 'password'"
                  class="mb-8"
                  color="secondary"
                  hint="Пароль"
                  persistent-hint
                  prepend-icon="mdi-lock-outline"
                  @click:append="show3 = !show3"
                  @keyup.enter="login"
                />
                <div
                  v-if="alert.show"
                  color="red"
                >
                  <font color="red">
                    {{ alert.error }}
                  </font>
                </div>
                <v-btn
                  :disabled="load"
                  min-width="250"
                  color="primary"
                  @click="login"
                >
                  Войти
                </v-btn>
                <v-btn
                  min-width="250"
                  color="primary"
                  text
                  @click="$router.push('/pages/recover')"
                >
                  Забыли пароль?
                </v-btn>
              </v-tab-item>
              <v-tab-item>
                <v-text-field
                  v-model="form.phone"
                  color="secondary"
                  type="number"
                  :label="label"
                  :prepend-icon="icon"
                  :counter="counter"
                  :maxlength="maxlength"
                  :rules="loginrules"
                  prefix="+7"
                  :disabled="sms.show || load"
                />
                <v-text-field
                  v-model="form.email"
                  color="secondary"
                  type="text"
                  label="E-mail"
                  :rules="[(v) => !!v || 'Неверное значение']"
                  prepend-icon="mdi-email"
                  :disabled="sms.show || load"
                />
                <v-text-field
                  v-model="form.password"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  color="secondary"
                  label="Введите пароль"
                  :rules="[rules.required, rules.min]"
                  hint="минимум 6 символов"
                  prepend-icon="mdi-lock-outline"
                  class="input-group--focused"
                  :disabled="sms.show || load"
                  @click:append="show1 = !show1"
                />
                <v-text-field
                  v-model="form.password2"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show2 ? 'text' : 'password'"
                  color="secondary"
                  label="Введите пароль"
                  :rules="[rules.required, rules.min, this.form.password == this.form.password2 || ('Введенные пароли не совпадают')]"
                  prepend-icon="mdi-lock-outline"
                  class="input-group--focused"
                  :disabled="sms.show || load"
                  @click:append="show2 = !show2"
                />
                <v-text-field
                  v-if="sms.show"
                  v-model="form.code"
                  :disabled="load"
                  class="mb-8"
                  color="secondary"
                  label="Введите код из смс для подтверждения регистрации"
                  prepend-icon="mdi-lock-outline"
                />
                <div
                  v-if="alert.show"
                  color="red"
                >
                  <font color="red">
                    {{ alert.error }}
                  </font>
                </div>
                <v-checkbox v-model="form.agreement">
                  <template v-slot:label>
                    <div>
                      Регистрируясь, вы даете согласие с
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href=""
                            @click.stop
                            v-on="on"
                          >
                            политикой конфиденциальности данных
                          </a>
                        </template>
                        Откроется в новом окне
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
                <v-btn
                  v-if="!sms.show"
                  color="primary"
                  :disabled="!form.agreement || !form.password || form.password.length<6 || form.password!=form.password2 || !form.phone"
                  min-width="250"
                  @click="send_sms"
                >
                  Зарегистрироваться
                </v-btn>
                <v-btn
                  v-else
                  color="primary"
                  :disabled="!form.code || form.code.length<4 || load"
                  min-width="250"
                  @click="register"
                >
                  Отправить
                </v-btn>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
    <v-dialog
      v-model="dialog.role.show"
      persistent
      max-width="420"
    >
      <v-card style="background-color:#eee">
        <v-card-title>
          <div class="m-login__header">
            <div class="site-logo" />
            <div class="m-login__text">
              ВОЙТИ КАК
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="(org,index) in dialog.role.user.organizations"
            :key="'_role' + index"
          >
            <v-col cols="12">
              <v-btn
                style="height: auto;"
                width="100%"
                @click="login_as(org)"
              >
                <div class="login-profile m-8-16">
                  <v-avatar>
                    <v-icon
                      large
                      color="rgb(121,114,118)"
                    >
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                  <div class="lp-row">
                    <div class="lp-col">
                      <div class="text_color_first user-role">
                        <span v-if="dialog.role.client[org.client]">{{ dialog.role.client[org.client].legal.name.short }}</span>
                      </div>
                      <div class="text_color_second user-role">
                        {{ dict.role[org.role] }}
                      </div>
                    </div>
                    <v-icon color="rgb(121,114,118)">
                      mdi-login-variant
                    </v-icon>
                  </div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style lang="scss">
  .m-login__header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .m-login__text {
      text-transform: uppercase;
      font-size: 16px;
      font-weight: 600;
      margin-top: 4px;
    }
  }
  .login-profile {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: start;
    &.m-8-16 {
      margin: 8px 16px;
    }
  }
  .lp-row {
    display: flex;
    width: 100%;
    margin-left: 8px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .lp-col {
    flex-direction: column;
  }

  .text_color_first {
    color: #315bbf;
  }
  .text_color_second {
    color: rgb(178,174,178);
  }
  .text_color_third {
    color: rgb(104,151,192);
  }
  .user-name {
    text-transform: uppercase;
    font-weight: 600;
  }
  .user-role {
    text-transform: none;
    font-size: 16px;
    width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
<script>
  import { setTimeout } from 'timers'
  export default {
    name: 'PagesLogin',
    data: () => ({
      field: {
        phone: false,
        email: false,
      },
      show1: false,
      show2: false,
      show3: false,
      rules: {
        required: value => !!value || 'Поле обязательное.',
        min: v => v.length >= 6 || 'Миниум 6 символов',
      },
      alert: {
        show: false,
        error: '',
      },
      load: false,
      sms: {
        show: false,
      },
      form: {
        surname: '',
        patronymic: '',
        name: '',
        phone: '',
        password: '',
        password2: '',
        key: '',
        code: '',
        recover: false,
      },
      dialog: {
        role: {
          show: false,
          user: {
            organizations: [],
          },
          client: {},
        },
      },
      dict: {
        role_area: {
          1: 'Административная область',
          2: 'Клиентский администратор',
          3: 'Личный кабинет покупателя',
          4: 'Клиентский администратор',
        },
        role: {
          1: 'Администратор',
          2: 'Клиентский администратор',
          3: 'Частное лицо',
          4: 'СКУД',
        },
      },
      phone: false,
    }),
    computed: {

      label: function () {
        if (this.form.phone) {
          const text = this.form.phone
          if (this.phone) {
            return 'Телефон'
          } else {
            return 'E-mail'
          }
        } else {
          return 'Телефон или e-mail'
        }
      },
      icon: function () {
        if (this.form.phone) {
          const text = this.form.phone
          if (this.phone) {
            return 'mdi-phone'
          } else {
            return 'mdi-email'
          }
        } else {
          return 'mdi-account'
        }
      },
      counter: function () {
        if (this.form.phone) {
          const text = this.form.phone
          if (this.phone) {
            return 10
          } else {
            return null
          }
        } else {
          return null
        }
      },
      maxlength: function () {
        if (this.form.phone) {
          const text = this.form.phone
          if (this.phone) {
            return 10
          } else {
            return null
          }
        } else {
          return null
        }
      },
      loginrules: function () {
        if (this.form.phone) {
          const text = this.form.phone
          if (this.phone) {
            return [(v) => { (/9\d{9}/.test(v) || v.length === 0) || 'Неверное значение' }]
          } else {
            return [(v) => { (v.indexOf('@') > -1 || v.length === 0) || 'Неверное значение' }]
          }
        } else {
          return null
        }
      },
    },
    methods: {
      login_input: function () {
        if (!this.form.phone) {
          this.phone = false
          return
        }
        if (this.form.phone.startsWith('+7')) {
          this.form.phone = this.form.phone.substring(2)
          this.phone = true
        } else if (this.form.phone.startsWith('79')) {
          this.form.phone = this.form.phone.substring(1)
          this.phone = true
        } else if (this.form.phone.startsWith('89')) {
          this.form.phone = this.form.phone.substring(1)
          this.phone = true
        }
      },
      login_as: function (role) {
        console.log('role', role)
        localStorage.removeItem('client')

        if (role.role === 1) {
          this.$router.push('/admin/payment/list')
        }
        if (role.role === 2) {
          localStorage.setItem('client', role.client)
          this.$router.push('/client/dashboard')
        }
        if (role.role === 3) {
          localStorage.setItem('client', role.client)
          this.$router.push('/common/services')
        }
        if (role.role === 4) {
          localStorage.setItem('client', role.client)
          this.$router.push('/client/skud/card/list')
        }
      },
      login: function () {
        this.load = true
        this.axios.post('/api/auth/login/', this.form)
          .then(response => {
            if (!response.data.error) {
              this.dialog.role.user = response.data.user

              for (const x in response.data.clients) {
                this.dialog.role.client[response.data.clients[x].id] = response.data.clients[x]
              }
              localStorage.setItem('token', response.data.token)
              if (response.data.user.organizations.length > 1) {
                this.dialog.role.show = true
              } else {
                this.login_as(response.data.user.organizations[0])
              }
            } else {
              this.load = false
              this.alert.error = 'Неправильный логин или пароль'
              this.alert.show = true
              setTimeout(() => { this.alert.show = false }, 5000)
            }
          })
          .catch(e => {
            this.load = false
            this.alert.error = 'Неправильный логин или пароль'
            this.alert.show = true
            setTimeout(() => { this.alert.show = false }, 5000)
          })
      },
      send_sms: function () {
        this.load = true
        this.axios.post('/api/auth/sms/', this.form)
          .then(response => {
            if (!response.data.error) {
              this.load = false
              this.form.key = response.data.data
              this.sms.show = true
            } else {
              this.load = false
              this.alert.error = response.data.data || 'Ошибка'
              this.alert.show = true
              setTimeout(() => { this.alert.show = false }, 5000)
            }
          })
          .catch(e => {
            this.load = false
            this.alert.error = 'Ошибка'
            this.alert.show = true
            setTimeout(() => { this.alert.show = false }, 5000)
          })
      },
      register: function () {
        this.load = true
        this.axios.post('/api/auth/register/', this.form)
          .then(response => {
            if (!response.data.error) {
              this.load = false
              localStorage.setItem('token', response.data.token)
              this.$router.push('/')
            } else {
              this.load = false
              this.alert.error = response.data.data || 'Ошибка'
              this.alert.show = true
              setTimeout(() => { this.alert.show = false }, 5000)
            }
          })
          .catch(e => {
            this.load = false
            this.alert.error = 'Ошибка'
            this.alert.show = true
            setTimeout(() => { this.alert.show = false }, 5000)
          })
      },
    },
  }
</script>

<!--<style>
.theme--light.v-icon {
    color: green !important;
}
</style>-->
